module.exports = __webpack_public_path__ + "img/Carbon_Pyrolysis.1654dbbe.jpg";